import React, { Component } from 'react';
import { createOptionalContext } from '../utils/create-optional-context.js';
const [GlobalActionsStackContext, GlobalActionsStackContextConsumer, GlobalActionsStackContextProvider, useGlobalActionsStack,] = createOptionalContext('GlobalActionsStackContext');
class GlobalActionsStackProvider extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            actionsStack: [],
            secondaryElementStack: [],
        };
        this.clearActions = () => {
            this.setState({ actionsStack: [] });
        };
        this.clearSecondaryElements = () => {
            this.setState({ secondaryElementStack: [] });
        };
        this.getActions = () => {
            const { actionsStack: actions } = this.state;
            const index = actions.length - 1;
            if (index < 0) {
                return null;
            }
            return actions[index];
        };
        this.getSecondaryElement = () => {
            const { secondaryElementStack } = this.state;
            const index = secondaryElementStack.length - 1;
            if (index < 0) {
                return null;
            }
            return secondaryElementStack[index];
        };
        this.popActions = () => {
            const { actionsStack } = this.state;
            const updatedStack = [...actionsStack];
            const actions = updatedStack.pop();
            this.setState({ actionsStack: updatedStack });
            return actions ?? null;
        };
        this.pushActions = (entry) => {
            const { actions = [] } = entry;
            if (actions.length > 2) {
                throw new Error('[Global Actions Stack]: The global actions stack area is limited to only two actions.');
            }
            this.setState(previousState => {
                const { actionsStack } = previousState;
                const updatedStack = [...actionsStack, entry];
                return {
                    actionsStack: updatedStack,
                };
            });
            return () => {
                this.setState((previousState) => {
                    const { actionsStack } = previousState;
                    const position = actionsStack.indexOf(entry);
                    if (position < 0) {
                        return null;
                    }
                    const updatedStack = [...actionsStack];
                    updatedStack.splice(position, 1);
                    return {
                        actionsStack: updatedStack,
                    };
                });
            };
        };
        this.pushSecondaryElement = (element) => {
            this.setState(previousState => {
                const { secondaryElementStack } = previousState;
                const updatedStack = [...secondaryElementStack, element];
                return {
                    secondaryElementStack: updatedStack,
                };
            });
            return () => {
                this.setState(previousState => {
                    const { secondaryElementStack } = previousState;
                    const position = secondaryElementStack.indexOf(element);
                    if (position < 0) {
                        return null;
                    }
                    const updatedStack = [...secondaryElementStack];
                    updatedStack.splice(position, 1);
                    return {
                        secondaryElementStack: updatedStack,
                    };
                });
            };
        };
    }
    render() {
        const { clearActions, clearSecondaryElements, getActions, getSecondaryElement, popActions, pushActions, pushSecondaryElement } = this;
        const { children } = this.props;
        const context = {
            clearActions,
            clearSecondaryElements,
            getActions,
            getSecondaryElement,
            popActions,
            pushActions,
            pushSecondaryElement,
        };
        return (React.createElement(GlobalActionsStackContextProvider, { value: context }, children));
    }
}
export { GlobalActionsStackContext, GlobalActionsStackContextConsumer, GlobalActionsStackProvider, useGlobalActionsStack, };
//# sourceMappingURL=global-actions-stack-context.js.map